// ** React Imports
import { Fragment, useState, useRef, useEffect } from "react"

// ** Third Party Components
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import { NavItem, NavLink, Button } from "reactstrap"
import { useNavigate } from "react-router-dom"
// ** Third Party Components
import { X } from "react-feather"
// import { handleMenuCollapsed } from "@store/layout"
// import { displayMenu } from "../../../../../../src/views/redux/store"
// import { useSelector } from "react-redux"
// ** Vertical Menu Components
import VerticalMenuHeader from "./VerticalMenuHeader"
import VerticalNavMenuItems from "./VerticalNavMenuItems"
import GlobalVariable from "../../../../../settings/global"
import themeConfig from "../../../../../configs/themeConfig"
import { isUserLoggedIn } from "../../../../../utility/Utils"
const headerText = GlobalVariable.headerText

// const trueBool = true
const Sidebar = (props) => {
  const navigate = useNavigate()
  // const dispatch = useDispatch()
  const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee
  // const stores = useSelector((state) => state.commonreducerSlice)
  // ** Props
  const { menuCollapsed, menu, skin, menuData, setMenuVisibility } = props

  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [currentActiveGroup, setCurrentActiveGroup] = useState([])
  const [activeItem, setActiveItem] = useState(null)

  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  //const [displayMenu, setDisplayMenu] = useState(false)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])
  // ** Ref
  const shadowRef = useRef(null)

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true)
  }

  // ** Scroll Menu
  const scrollMenu = (container) => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains("d-block")) {
        shadowRef.current.classList.add("d-block")
      }
    } else {
      if (shadowRef.current.classList.contains("d-block")) {
        shadowRef.current.classList.remove("d-block")
      }
    }
  }

  // async function displayFunction() {
  //   await dispatch(displayMenu(!stores?.displayMenuBool))
  // }

  const navigateMainPage = () => {
    sessionStorage.setItem('pageTransition', 'LR')
    if (isEmployee) {
      if (location.pathname === '/Publications') {
        navigate('/home')
      }
    } else {
      const user = JSON.parse(isUserLoggedIn())
      const userAgents = user?.userData?.userAgents || []

      if (userAgents.length > 0) {
      } else {
        navigate('/verificationDetails')
      }
    }
  }

  return (
    <Fragment>
      <div
        className={classnames(
          "main-menu menu-fixed menu-accordion menu-shadow",
          {
            expanded: menuHover || menuCollapsed === false,
            "menu-light": skin !== "semi-dark" && skin !== "dark",
            "menu-dark": skin === "semi-dark" || skin === "dark"
          }
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setMenuHover(false)}
      // style={{
      //   width: menuCollapsed ? '225px' : '225px', background: 'none'
      //   // , boxShadow: '10px 0 5px -5px #e9dede' 
      // }}
      >
        {menu ? (
          menu({ ...props })
        ) : (
          <Fragment>
            {/* Vertical Menu Header */}
            <VerticalMenuHeader
              setGroupOpen={setGroupOpen}
              menuHover={menuHover}
              {...props}
            />
            {/* Vertical Menu Header Shadow */}
            <div className="shadow-bottom" ref={shadowRef}></div>
            {/* Perfect Scrollbar */}
            <PerfectScrollbar
              className="main-menu-content transitionProperty"
              options={{ wheelPropagation: false }}
              onScrollY={(container) => scrollMenu(container)}
              style={{ background: '#fff' }}
            >
              {windowWidth > 1200 && <ul className="nav navbar-nav text-center menuVisible_main">
                <li className="nav-item">
                  <NavLink
                    className=""
                    onClick={() => navigateMainPage()}
                  >
                    <span className="brand-logo">
                      <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
                    </span>
                  </NavLink>
                </li>
              </ul>}
              <ul className="navigation navigation-main">
                {
                  windowWidth <= 1200 &&
                  <li className="nav-item d-flex">
                    <NavLink
                      className="mobileMenu"
                      onClick={() => navigateMainPage()}
                    >
                      <span className="brand-logo">
                        <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
                      </span>
                    </NavLink>
                    <NavLink
                      className={menuCollapsed ? "nav-menu-main menu-toggle  hidden-xs is-active" : "nav-menu-main menu-toggle hidden-xs is-active p-0"}
                      style={{ top: headerText ? '22px' : '10px', display: windowWidth <= 1200 ? "unset" : "none", marginTop: "15px", marginLeft: "10px" }}
                      onClick={() => {
                        setMenuVisibility(false)
                        // displayFunction()
                        // dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
                      }}
                    >
                      <X className="ficon" size={30} />
                    </NavLink>
                  </li>
                }

                <NavItem className="mobile-menu me-auto menu_visible " style={{ marginBottom: '0.8rem' }}>
                  {/* <NavItem className="mobile-menu me-auto cancelmenu"> */}

                  {/* </NavItem> */}
                </NavItem>
                <VerticalNavMenuItems
                  items={menuData}
                  menuData={menuData}
                  menuHover={menuHover}
                  groupOpen={groupOpen}
                  activeItem={activeItem}
                  groupActive={groupActive}
                  setGroupOpen={setGroupOpen}
                  menuCollapsed={menuCollapsed}
                  setActiveItem={setActiveItem}
                  setGroupActive={setGroupActive}
                  currentActiveGroup={currentActiveGroup}
                  setCurrentActiveGroup={setCurrentActiveGroup}
                />
              </ul>
            </PerfectScrollbar>
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

export default Sidebar
